// PRE ORDER FOR VARIANTS
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant,
    
  // dev = document.querySelector('#output'),
  po_message = document.querySelector('.PreOrderMessage'),
  lowstock_message = document.querySelector('.LowStockMessage'),
  addToCartButton = document.querySelector('.ProductForm__AddToCart'),  
  productButton = document.querySelector('.ProductForm__AddToCart span'),
  inv_input = document.querySelector('.inventory_when_added'),
  mess = po_msg_js,
  cap =  po_cap_qty_js;

  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var variantsInventories = jsonData['inventories'] || {};

  var qty = variantsInventories[variant.id].inventory_quantity;
  
  if (variant.available) {

    if (qty < 1 && qty >= cap) {
      // IN PO RANGE
      po_message.style.display = '';
      lowstock_message.style.display = 'none';
      lowstock_message.innerText = '';  
      productButton.innerText = 'Back Order';
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.remove('Button--secondary', 'soldout');
      inv_input.name = 'properties[_stock]';
      inv_input.value = qty;
      
    } else if (qty < cap) {
      // BELOW CAP
      po_message.style.display = 'none';
      lowstock_message.style.display = 'none';
      lowstock_message.innerText = '';  
      productButton.innerText = 'Sold Out';
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('Button--secondary', 'soldout');
      inv_input.name = '';
      inv_input.value = '';
      
    } else if (qty > 0 && qty < 4) {
      // LOW STOCK
      po_message.style.display = 'none';
      lowstock_message.style.display = '';
      lowstock_message.innerText = 'Only ' + qty + ' remaining in stock';
      productButton.innerText = 'Add To Cart';
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.remove('Button--secondary', 'soldout');
      inv_input.name = '';
      inv_input.value = '';
      
    } else {
      // IN STOCK
      po_message.style.display = 'none';
      lowstock_message.style.display = 'none';
      lowstock_message.innerText = '';  
      productButton.innerText = 'Add To Cart';
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.remove('Button--secondary', 'soldout');
      inv_input.name = '';
      inv_input.value = '';
    }
    
  } else {
    // SOLD OUT
      // dev.innerText =  'stock ' + qty + ' cap: ' + cap;
      po_message.style.display = 'none';
      lowstock_message.style.display = 'none';
      lowstock_message.innerText = '';  
      productButton.innerText = 'Sold Out';
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('Button--secondary', 'soldout');
      inv_input.name = '';
      inv_input.value = '';
    
  }
});
